"use client"

import React, { createContext, useContext, useState, useCallback } from 'react';
import TechnicalErrorModal from '@/components/TechnicalErrorModal/TechnicalErrorModal.jsx';

const ErrorModalContext = createContext({
  showTechnicalError: () => {},
});

export const useErrorModal = () => {
  const context = useContext(ErrorModalContext);
  if (!context) {
    throw new Error('useErrorModal must be used within ErrorModalProvider');
  }
  return context;
};

export const ErrorModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showTechnicalError = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = async () => {
    // Clear localStorage
    localStorage.clear();
    
    // Close modal
    setIsModalOpen(false);
    
    // Reload the page to start over
    window.location.reload();
  };

  return (
    <ErrorModalContext.Provider value={{ showTechnicalError }}>
      {children}
      <TechnicalErrorModal 
        isOpen={isModalOpen} 
        onClose={handleModalClose}
      />
    </ErrorModalContext.Provider>
  );
};